import { render, staticRenderFns } from "./VCardSala.vue?vue&type=template&id=06c5af3d&scoped=true"
import script from "./VCardSala.vue?vue&type=script&lang=js"
export * from "./VCardSala.vue?vue&type=script&lang=js"
import style0 from "./VCardSala.vue?vue&type=style&index=0&id=06c5af3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5af3d",
  null
  
)

export default component.exports